module.exports = Object.freeze({
  'res': `{
  "message": "Grufity API Service is healthy"
}`,
},);
